module.exports = __webpack_public_path__ + "assets/img/00038.5733b4dd.png";